module.exports = __webpack_public_path__ + "media/buy-now/bag8-50652e12.png";